module.exports = __webpack_public_path__ + "img/workflow-edit-icon.aa00fdcb.svg";